import { render, staticRenderFns } from "./reasonAddPage.vue?vue&type=template&id=0353be4e&scoped=true&"
import script from "./reasonAddPage.vue?vue&type=script&lang=js&"
export * from "./reasonAddPage.vue?vue&type=script&lang=js&"
import style0 from "./reasonAddPage.vue?vue&type=style&index=0&id=0353be4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353be4e",
  null
  
)

export default component.exports